export const Types = {
  GET_LIST_RELATORIO_METAS: "relatorioMetas/GET_LIST_RELATORIO_METAS",
  GET_LIST_RELATORIO_METAS_SUCCESS:
    "relatorioMetas/GET_LIST_RELATORIO_METAS_SUCCESS",
  GET_LIST_RELATORIO_METAS_BASE_SUCCESS:
    "relatorioMetas/GET_LIST_RELATORIO_METAS_BASE_SUCCESS"
};

const INITIAL_STATE = {
  data: [],
  value_base: null,
  total_other: 0,
  total_production: 0
};

export default function relatorioMetas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_RELATORIO_METAS:
      return { ...state };
    case Types.GET_LIST_RELATORIO_METAS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        past_working_days: action.payload.past_working_days,
        working_days_in_month: action.payload.working_days_in_month,
        total_reached_goal: action.payload.total_reached_goal,
        total_not_reached_goal: action.payload.total_not_reached_goal
      };
    case Types.GET_LIST_RELATORIO_METAS_BASE_SUCCESS:
      return {
        ...state,
        value_base: action.payload.data
      };
    default:
      return state;
  }
}

export const Creators = {
  getListMetasRelatorio: filtro => ({
    type: Types.GET_LIST_RELATORIO_METAS,
    payload: { filtro }
  }),
  getListMetasSuccess: (data, past_working_days, working_days_in_month, total_reached_goal, total_not_reached_goal) => ({
    type: Types.GET_LIST_RELATORIO_METAS_SUCCESS,
    payload: { data, past_working_days, working_days_in_month, total_reached_goal, total_not_reached_goal }
  }),
  getListMetasBaseSuccess: data => ({
    type: Types.GET_LIST_RELATORIO_METAS_BASE_SUCCESS,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/relatorioMetas.js